export default "__VITE_ASSET__BPlBmnb2__"